





/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// DELETESTAKENOWSECTION
// DELETESTAKENOWSECTION


const DELETESTAKENOWSECTION= createAsyncThunk(
  "deleteStakeNowSection/deleteStakeNowSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const deleteStakeNowSectionSlice = createSlice({
  name: "deleteStakeNowSectionSlice",
  initialState: {
    deleteStakeNowSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdeleteStakeNowSection: (state) => {
        state.deleteStakeNowSection.loading = false
        state.deleteStakeNowSection.error = false
        state.deleteStakeNowSection.data = []
        state.deleteStakeNowSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DELETESTAKENOWSECTION.fulfilled, (state, action) => {
      state.deleteStakeNowSection = {
        ...state.deleteStakeNowSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETESTAKENOWSECTION.pending, (state, action) => {
      state.deleteStakeNowSection = {
        ...state.deleteStakeNowSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETESTAKENOWSECTION.rejected, (state, action) => {
      state.deleteStakeNowSection = {
        ...state.deleteStakeNowSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const deleteStakeNowSectionAction = {
    DELETESTAKENOWSECTION,
};

export { deleteStakeNowSectionAction };
export default deleteStakeNowSectionSlice.reducer;
export const {setInitialStateOfdeleteStakeNowSection} = deleteStakeNowSectionSlice.actions
